export function externalShipmentWithLabelValidate(external_shipment){
    var result = true;
    var errors = [];
    result = validateClientId(external_shipment.client_id, errors);
    result = validateChannelSale(external_shipment.channel_sale, errors);
    result = validateUniqueOrderNumber(external_shipment.unique_order_number, errors);
    result = validateTotalPrice(external_shipment.total_price, errors);
    result = validateConsignee(external_shipment.consignee, errors);
    result = validateProducts(external_shipment.products);
    result = validateKits(external_shipment.kits);
    result = validateAtLeastOneProduct(external_shipment.products, external_shipment.kits, errors);
    result = validateBoxes(external_shipment.boxes);

    if(!result) return errors;
    else return result;
}

function validateClientId(client_id, errors){    
    if(Number.isInteger(client_id)) return true;
    else { 
        errors.push("client_id_not_valid");
        return false;
    }
}

function validateChannelSale(channel_sale, errors){
    if(typeof channel_sale === 'string' && channel_sale.trim() !== '') return true;
    else {
        errors.push("channel_sale_not_valid");
        return false;
    }
}

function validateUniqueOrderNumber(uon, errors){
    if(typeof uon === 'string' && uon.trim() !== '') return true;
    else {
        errors.push("uon_not_valid")
        return false;
    } 
}

function validateTotalPrice(total_price, errors){
    if(/^([1-9]\d*|0)(\.\d+)?$/.test(total_price)) return true;
    else {
        errors.push("total_price_not_valid")
        return false;
    }
}

function validateConsignee(consignee, errors){
    if(typeof consignee.name !== 'string' || consignee.name.trim() === '') { errors.push("consignee_name_not_valid"); return false }
    if(typeof consignee.country !== 'string' || consignee.country.trim() === '') { errors.push("consignee_country_not_valid"); return false }
    if(typeof consignee.state !== 'string' || consignee.state.trim() === '') { errors.push("consignee_state_not_valid"); return false }
    if(typeof consignee.municipality !== 'string' || consignee.municipality.trim() === '') { errors.push("consignee_municipality_not_valid"); return false }
    if(typeof consignee.neighborhood !== 'string' || consignee.neighborhood.trim() === '') { errors.push("consignee_neighborhood_not_valid"); return false }
    if(typeof consignee.street_line !== 'string' || consignee.street_line.trim() === '') { errors.push("consignee_street_line_not_valid"); return false }
    if(typeof consignee.postal_code !== 'string' || consignee.postal_code.trim() === '') { errors.push("consignee_postal_code_not_valid"); return false }
    if(typeof consignee.phone !== 'string' || consignee.phone.trim() === '') { errors.push("consignee_phone_not_valid"); return false }

    return true;
}

function validateProducts(products){
    return Array.isArray(products) &&
        products.every(item =>
        typeof item === 'object' &&
        item !== null &&
        !isNaN(item.id) &&
        !isNaN(item.quantity)&&
        !isNaN(item.unit_price)
    );
}

function validateKits(kits){
    return Array.isArray(kits) &&
        kits.every(item =>
        typeof item === 'object' &&
        item !== null &&
        !isNaN(item.id) &&
        !isNaN(item.quantity)&&
        !isNaN(item.unit_price)
    );
}

function validateAtLeastOneProduct(products, kits){
    return Array.isArray(kits) && Array.isArray(products) && (products.length > 0 || kits.length > 0);
}

function validateBoxes(boxes){
    return Array.isArray(boxes) &&
        boxes.length > 0 &&
        boxes.every(item =>
        typeof item === 'object' &&
        item !== null &&
        !isNaN(item.id) &&
        !isNaN(item.quantity)&&
        !isNaN(item.weight)
    );
}
